module.exports = __webpack_public_path__ + "assets/complianz.b3044295.svg";